import React, { useRef, Component } from 'react';
import { motion, useInView } from 'framer-motion';
import { ShieldCheckIcon, VolumeXIcon, ThermometerSnowflakeIcon, CarIcon, WifiIcon, ArrowUpToLineIcon, DoorOpenIcon, DropletsIcon } from 'lucide-react';
interface Feature {
  icon: React.ElementType;
  title: string;
  description: string;
}
const features: Feature[] = [{
  icon: VolumeXIcon,
  title: 'Akustický komfort',
  description: 'Příčky Fermacell s útlumem až 65 dB a minerální vata v podlahách pro maximální soukromí a klid.'
}, {
  icon: ThermometerSnowflakeIcon,
  title: 'Klima a vytápění',
  description: 'Nízkoteplotní podlahové vytápění a stavební příprava pro klimatizaci ve všech obytných místnostech.'
}, {
  icon: ShieldCheckIcon,
  title: 'Bezpečnost',
  description: 'Vstupní dveře bezpečnostní třídy RC2, kamerový systém ve společných prostorách a automatické odvětrávání.'
}, {
  icon: CarIcon,
  title: 'Parkování',
  description: 'K dispozici je vlastní vnitřní garážové stání pro 1 auto a další venkovní stání před garáží.'
}, {
  icon: ArrowUpToLineIcon,
  title: 'Nový výtah',
  description: 'V rámci rekonstrukce domu bude instalován zcela nový moderní výtah pro pohodlný přístup.'
}, {
  icon: WifiIcon,
  title: 'Moderní sítě',
  description: 'Optický kabel přiveden do každého bytu a datové rozvody (UTP) v každé obytné místnosti.'
}, {
  icon: DoorOpenIcon,
  title: 'Prémiové materiály',
  description: 'Třívrstvé dubové podlahy Princ Parket, velkoformátové obklady a bezfalcové interiérové dveře.'
}, {
  icon: DropletsIcon,
  title: 'Moderní koupelny',
  description: 'Bezbariérové walk-in sprchy s nerezovým žlabem, závěsné WC s technologií Rimless a designové baterie.'
}];
export function Features() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const isInView = useInView(sectionRef, {
    once: true,
    margin: '-80px'
  });
  return <section id="features" ref={sectionRef} className="w-full bg-villa-bg py-24 md:py-32 px-6 md:px-10 transition-colors duration-500" aria-label="Přednosti projektu" data-id="element-53">
      <div className="max-w-6xl mx-auto" data-id="element-54">
        <motion.p initial={{
        opacity: 0,
        y: 16
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} className="text-villa-gold text-[12px] tracking-[0.3em] uppercase font-inter font-light mb-6" data-id="element-55">
          Přednosti
        </motion.p>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7,
        delay: 0.1,
        ease: 'easeOut'
      }} className="font-playfair text-villa-text text-3xl md:text-4xl lg:text-5xl font-medium mb-16 leading-tight" data-id="element-56">
          Bydlení bez kompromisů
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-[var(--color-border-subtle)]" data-id="element-57">
          {features.map((feature, i) => {
          const IconComponent = feature.icon;
          return <motion.article key={feature.title} initial={{
            opacity: 0,
            y: 24
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.6,
            delay: 0.15 + i * 0.07,
            ease: 'easeOut'
          }} className="bg-villa-bg p-8 md:p-10 transition-colors duration-500" data-id="element-58">
                <IconComponent className="w-7 h-7 text-villa-gold mb-6" strokeWidth={1.2} aria-hidden="true" data-id="element-59" />
                <h3 className="font-playfair text-villa-text text-xl font-medium mb-3" data-id="element-60">
                  {feature.title}
                </h3>
                <p className="font-inter text-villa-text/50 text-sm leading-[1.8] font-light" data-id="element-61">
                  {feature.description}
                </p>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}